import axios from 'axios'
import router from '../router'
import { browser } from './ua'
import { callbackify } from 'util';
import { webTracker } from '../utils/tracker'
import { Message } from 'element-ui'

export const baseURL = process.env.VUE_APP_URL + 'search';
const request = axios.create({
  baseURL: baseURL
});
request.interceptors.request.use(function (config) {
  // 在发送请求之前
  let token = localStorage.getItem('PUBMEDSEARCHTOKEN')
  let uid = localStorage.getItem('PUBMEDWXUNIONID');
  if (uid && browser.ua.weixin) {
    if (config.method == 'get') {
      config.params = {
        ...config.params,
        uid: uid
      }
    } else {
      config.data = {
        ...config.data,
        uid: uid
      }
    }
  }
  if (token && !browser.ua.mobile || (token && browser.ua.iPad)) {
    config.headers.Authorization = token;
  }
  // console.log(config)
  return config
}, function (error) {　 // 对请求错误
  return Promise.reject(error)
});

// 添加响应拦截器
request.interceptors.response.use(function (response) {　 // 对响应数据做点什么
  // console.log(response);
  if (response.data.status == '-2') {
    localStorage.clear();
    // router.push('/login');
    console.log(response)
    console.log('失效了')
    let Logger = webTracker();
    Logger.push('userHeadImg', window.localStorage.getItem('PUMMEDSEARCHHEADIMG'));
    Logger.push('userName', window.localStorage.getItem('PUMMEDSEARCHUSERNAME'));
    Logger.push('response_warning_code', response.data.status);
    Logger.push('response_warning_message', response.data.message);
    Logger.logger()
    // alert('登录超时，请重新登录')
    // Message({
    //     message: '登录超时，请重新登录',
    //     type: 'warning'
    // });
    if (browser.ua.weixin) {
      console.log('重新授权')
      window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx82e57c9f12fe7eac&redirect_uri=https%3A//ts.midbj.com/doc_search/&response_type=code&scope=snsapi_base&state=wxbase#wechat_redirect')
      router.replace({ path: '/' })
    } else if (browser.ua.mobile && !browser.ua.iPad) {
      router.replace({ path: '/mobile' })
    } else {
      window.localStorage.setItem('REDIRECT', window.location.href);
      router.replace({ path: '/login' })
    }
  } else {
    return response
  }
}, function (error) {　　 // 对响应错误做点什么
  console.log(error)
  let Logger = webTracker();
  Logger.push('userHeadImg', window.localStorage.getItem('PUMMEDSEARCHHEADIMG'));
  Logger.push('userName', window.localStorage.getItem('PUMMEDSEARCHUSERNAME'));
  Logger.push('response_error_code', error.response.status);
  Logger.push('response_error_config', JSON.stringify(error.response.config));
  Logger.logger()
  if (error.response.status === 401) {
    // 401 说明 token 验证失败
    // 可以直接跳转到登录页面，重新登录获取 token
    localStorage.clear();
    window.localStorage.setItem('REDIRECT', window.location.href);

    // alert('登录超时，请重新登录')
    // Message({
    //     message: '登录超时，请重新登录',
    //     type: 'warning'
    // });
    if (browser.ua.mobile && !browser.ua.iPad) {
      router.replace({ path: '/mobile' })
    } else {
      router.replace({ path: '/login' })
    }
  } else if (error.response.status === 502) {
    // 请求超时
    // alert('网络居然超时了>_<')
    Message({
      message: '网络居然超时了>_<',
      type: 'error'
    });
  } else if (error.response.status === 500) {
    // 服务器错误
    // alert('网络居然崩溃了>_<')
    Message({
      message: '网络居然崩溃了>_<',
      type: 'error'
    });
  } else {
    return Promise.reject(error)
  }
  return Promise.reject(error.response.data)
});

export default async (type = 'GET', url = '', data = {}, progress) => {
  type = type.toLowerCase()
  if (type === 'get') {
    return request({
      url: url,
      method: type,
      params: data
    })
  } else {
    return request({
      url: url,
      method: type,
      data: data,
      onDownloadProgress: progress
    })
  }
}


// WEBPACK FOOTER //
// ./src/config/request.js